import { api } from "../../libs/axios";

export async function consultarPagamentoPos(id: string) {
  const response = await api.get(`/checkout/pos/consultar/${id}`);

  return response.data;
}
